export default __webpack_public_path__ + "static/media/UI_ButtonCommentSendActive.9a5a088d.png";